import { render, staticRenderFns } from "./RelaterDialog.vue?vue&type=template&id=39760974&"
import script from "./RelaterDialog.vue?vue&type=script&lang=js&"
export * from "./RelaterDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelaterDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RelaterDialog.vue"
export default component.exports